/* Unplug Wholesale: Scent Guard
   Added Sept 2026. Blocks checkout when a scented product is in the cart
   without a fragrance choice (this happens when Reorder Master re-adds
   private label items, because it skips the Infinite Options fields).
   Also handles the "Choose scent" fix flow on the product page.
*/
(function () {
  'use strict';

  // Products whose fragrance is chosen through Infinite Options (no Fragrance variant).
  // Any product whose title starts with "Private Label" is covered automatically.
  var SCENTED_HANDLES = [
    'private-label-fluted-glass-candle',
    'private-label-mysa-grand-3-wick-candle-large',
    'private-label-mysa-lagom-3-wick-candle-medium',
    'private-label-mysa-petite-1-wick-candle-small',
    'private-label-unplug-home-spray',
    'private-label-gold-hammered-candle',
    'private-label-reed-diffusers',
    'private-label-car-air-freshener-diffuser',
    'custom-tin-candle',
    '9-oz-apothecary-glass-candle-1-wick',
    '14-oz-apothecary-glass-candle-2-wick',
    'mysa-grand-3-wick-candle-large',
    'mysa-lagom-3-wick-candle-medium',
    'mysa-petite-1-wick-candle-small',
    'unplug-home-spray-retail-ready',
    'fluted-glass-candle',
    'luxe-reed-diffuser-set'
  ];

  var MSG_LINE = 'Scent needed before checkout. This item was added without a fragrance choice (this happens with Reorder). Pick the scent so it prints on your invoice and our production sheet.';
  var MSG_BLOCK = 'Almost there! {n} item{s} in your cart still need a scent selected. Use the Choose scent button on each item, then check out.';
  var MSG_PRODUCT = 'Reorder: choose your scent below and click Add to cart. We will swap this in for the unscented item already in your cart.';

  function needsScent(item) {
    var handle = (item.handle || '').toLowerCase();
    var title = (item.product_title || '').toLowerCase();
    return SCENTED_HANDLES.indexOf(handle) !== -1 || title.indexOf('private label') === 0;
  }

  function hasScent(item) {
    var i, k, v;
    var opts = item.options_with_values || [];
    for (i = 0; i < opts.length; i++) {
      k = String(opts[i].name || '').toLowerCase();
      if (k.indexOf('fragrance') !== -1 || k.indexOf('scent') !== -1) return true;
    }
    var props = item.properties || {};
    for (k in props) {
      if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
      v = String(props[k] == null ? '' : props[k]).trim();
      var lk = k.toLowerCase();
      if (lk === 'fragrance collection') continue;
      if (!v) continue;
      if (lk.indexOf('fragrance') !== -1 || lk.indexOf('scent') !== -1) return true;
    }
    return false;
  }

  function missingLines(cart) {
    var out = [];
    (cart.items || []).forEach(function (item, idx) {
      if (needsScent(item) && !hasScent(item)) {
        out.push({ item: item, index: idx + 1 });
      }
    });
    return out;
  }

  function injectStyles() {
    if (document.getElementById('scent-guard-css')) return;
    var css = '' +
      '.scent-guard-alert{margin:.8rem 0 0;padding:.9rem 1rem;border:1px solid #c7a15a;background:#fff7e6;border-radius:6px;font-size:1.3rem;line-height:1.5;color:#3a3a3a}' +
      '.scent-guard-alert strong{display:block;margin-bottom:.3rem}' +
      '.scent-guard-alert a.button{margin-top:.7rem;min-height:3.6rem;font-size:1.3rem}' +
      '.scent-guard-block{margin:0 0 1.2rem;padding:1rem 1.2rem;border:1px solid #c7a15a;background:#fff7e6;border-radius:6px;font-size:1.4rem;line-height:1.5}' +
      '.scent-guard-disabled{opacity:.45;pointer-events:none}' +
      '.scent-guard-product{margin:0 0 1.5rem;padding:1rem 1.2rem;border:1px solid #c7a15a;background:#fff7e6;border-radius:6px;font-size:1.4rem;line-height:1.5}';
    var s = document.createElement('style');
    s.id = 'scent-guard-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function fixUrl(item) {
    var url = item.url || ('/products/' + item.handle);
    url = url.split('?')[0];
    return url + '?variant=' + item.variant_id + '&scent_fix=' + encodeURIComponent(item.key) + '&qty=' + item.quantity;
  }

  function findRow(index, item) {
    var row = document.getElementById('CartItem-' + index) || document.getElementById('CartDrawer-Item-' + index);
    if (row) return row;
    var btn = document.querySelector('[data-index="' + index + '"]');
    if (btn) return btn.closest('.cart-item') || btn.closest('tr') || btn.closest('li');
    return null;
  }

  function decorateCartPage(cart) {
    injectStyles();
    document.querySelectorAll('.scent-guard-alert, .scent-guard-block').forEach(function (n) { n.remove(); });
    var missing = missingLines(cart);

    missing.forEach(function (m) {
      var row = findRow(m.index, m.item);
      if (!row) return;
      var host = row.querySelector('.cart-item__details') || row.querySelector('.cart-item__name') || row;
      var box = document.createElement('div');
      box.className = 'scent-guard-alert';
      box.setAttribute('data-scent-guard-line', m.item.key);
      var strong = document.createElement('strong');
      strong.textContent = 'Scent needed before checkout';
      var p = document.createElement('div');
      p.textContent = MSG_LINE;
      var a = document.createElement('a');
      a.className = 'button button--secondary';
      a.href = fixUrl(m.item);
      a.textContent = 'Choose scent';
      box.appendChild(strong);
      box.appendChild(p);
      box.appendChild(a);
      host.appendChild(box);
    });

    var checkoutBtns = document.querySelectorAll('button[name="checkout"], #checkout, #CartDrawer-Checkout, .cart__checkout-button');
    var extra = document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons');
    if (missing.length) {
      var n = missing.length;
      var block = document.createElement('div');
      block.className = 'scent-guard-block';
      block.textContent = MSG_BLOCK.replace('{n}', n).replace('{s}', n === 1 ? '' : 's');
      checkoutBtns.forEach(function (b) {
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('aria-disabled', 'true');
        b.setAttribute('data-scent-blocked', '1');
        if (!b.parentNode.querySelector('.scent-guard-block')) b.parentNode.insertBefore(block.cloneNode(true), b);
      });
      extra.forEach(function (e) { e.classList.add('scent-guard-disabled'); });
    } else {
      checkoutBtns.forEach(function (b) {
        if (b.getAttribute('data-scent-blocked')) {
          b.removeAttribute('disabled');
          b.removeAttribute('aria-disabled');
          b.removeAttribute('data-scent-blocked');
        }
      });
      extra.forEach(function (e) { e.classList.remove('scent-guard-disabled'); });
    }
    document.body.setAttribute('data-scent-missing', missing.length ? '1' : '0');
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { decorateCartPage(cart); return cart; })
      .catch(function () {});
  }

  function isCheckoutControl(el) {
    if (!el || !el.closest) return null;
    return el.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout, .cart__checkout-button, a[href*="/checkout"], .shopify-payment-button, .cart__dynamic-checkout-buttons, .additional-checkout-buttons');
  }

  function blockedNow() {
    return document.body.getAttribute('data-scent-missing') === '1';
  }

  function scrollToFirstAlert() {
    var first = document.querySelector('.scent-guard-alert');
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function guardCheckoutClicks() {
    document.addEventListener('click', function (e) {
      if (!blockedNow()) return;
      if (isCheckoutControl(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollToFirstAlert();
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (!blockedNow()) return;
      if ((e.key === 'Enter' || e.key === ' ') && isCheckoutControl(e.target)) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    }, true);
    // Keep the button visibly disabled even when the theme re-enables it after a cart render.
    setInterval(function () {
      if (!blockedNow()) return;
      document.querySelectorAll('button[name="checkout"], #checkout, #CartDrawer-Checkout, .cart__checkout-button').forEach(function (b) {
        if (!b.disabled) { b.setAttribute('disabled', 'disabled'); b.setAttribute('data-scent-blocked', '1'); }
      });
    }, 500);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.getAttribute('action') === null) return;
      var action = form.getAttribute('action') || '';
      var submitter = e.submitter;
      var isCheckout = /\/checkout/.test(action) || (submitter && submitter.name === 'checkout');
      if (isCheckout && blockedNow()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        scrollToFirstAlert();
      }
    }, true);
  }

  function watchCartUpdates() {
    // Re-run after the theme re-renders cart sections (quantity change, remove, etc.)
    var origFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      return origFetch.apply(this, args).then(function (res) {
        if (/\/cart\/(change|update|add|clear)/.test(url)) {
          setTimeout(refreshCart, 350);
        }
        return res;
      });
    };
    var mo = new MutationObserver(function () {
      if (mo._t) return;
      mo._t = setTimeout(function () {
        mo._t = null;
        if (!document.querySelector('.scent-guard-alert') && document.body.getAttribute('data-scent-missing') === '1') refreshCart();
      }, 400);
    });
    var target = document.querySelector('#main-cart-items, cart-items, cart-drawer') || document.body;
    mo.observe(target, { childList: true, subtree: true });
  }

  function productFixFlow() {
    var params = new URLSearchParams(window.location.search);
    var key = params.get('scent_fix');
    if (!key) return;
    var qty = parseInt(params.get('qty') || '1', 10);
    injectStyles();

    var form = document.querySelector('form[action*="/cart/add"]');
    var host = document.querySelector('.product__info-container') || (form && form.parentNode) || document.querySelector('main');
    if (host) {
      var note = document.createElement('div');
      note.className = 'scent-guard-product';
      note.textContent = MSG_PRODUCT;
      var anchor = host.querySelector('.product__title') || host.firstElementChild;
      if (anchor && anchor.parentNode === host) host.insertBefore(note, anchor.nextSibling); else host.insertBefore(note, host.firstChild);
    }

    function setQty() {
      var q = document.querySelector('input[name="quantity"]');
      if (q && qty > 0) { q.value = qty; q.dispatchEvent(new Event('change', { bubbles: true })); }
    }
    setQty();
    setTimeout(setQty, 1200);

    var origFetch = window.fetch;
    var done = false;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var p = origFetch.apply(this, args);
      if (!done && /\/cart\/add/.test(url)) {
        p.then(function (res) {
          if (res && res.ok) {
            done = true;
            origFetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            }).catch(function () {}).then(function () {
              setTimeout(function () { window.location.href = '/cart'; }, 600);
            });
          }
        }).catch(function () {});
      }
      return p;
    };
  }

  function init() {
    if (document.querySelector('form[action*="/cart/add"]') && /scent_fix=/.test(window.location.search)) {
      productFixFlow();
    }
    var onCart = /^\/cart\/?$/.test(window.location.pathname) || document.querySelector('cart-items, #main-cart-items, cart-drawer');
    if (onCart) {
      guardCheckoutClicks();
      watchCartUpdates();
      refreshCart();
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();